import React from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import CurrencyInput from '../CurrencyInput';

function CompensacoesModal({ show, onClose, onSubmit, form, handleChange, programas = [] }) {
  const [contas, setContas] = React.useState([]);
  const isEditing = form._isEditing;

  React.useEffect(() => {
    if (!show || !form.idPrograma) {
      setContas([]);
      return;
    }
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    axios.get(`${API_BASE_URL.CONTA}/findByEscolaAndPrograma`, {
      params: { idEscola: cnpj, idPrograma: form.idPrograma },
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => {
      const data = Array.isArray(r.data) ? r.data : [];
      function parseContaNum(numConta) {
        const m = String(numConta).match(/^(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      }
      setContas([...data].sort((a, b) => {
        const nA = parseContaNum(a.numConta);
        const nB = parseContaNum(b.numConta);
        if (nA !== nB) return nA - nB;
        return String(a.numConta).localeCompare(String(b.numConta));
      }));
      if (data.length === 1) {
        handleChange({ target: { name: 'idConta', value: data[0].numConta } });
      }
    }).catch(() => setContas([]));
  }, [show, form.idPrograma]);

  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-balance-scale me-2"></i>CADASTRO DE COMPENSAÇÃO</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Programa *</label>
                  <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Conta *</label>
                  <select className="form-select form-select-sm" name="idConta" value={form.idConta} onChange={handleChange} required disabled={!form.idPrograma || isEditing}>
                    <option value="">{form.idPrograma ? 'Selecione...' : 'Selecione o programa'}</option>
                    {contas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label className="form-label">Valor Custeio</label>
                  <CurrencyInput className="form-control form-control-sm" name="vlrC" value={form.vlrC} onChange={handleChange} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label className="form-label">Valor Capital</label>
                  <CurrencyInput className="form-control form-control-sm" name="vlrK" value={form.vlrK} onChange={handleChange} />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompensacoesModal;
